"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var router_1 = require("@angular/router");
var register_component_1 = require("./register/register.component");
var routes = [
    { path: 'registration', component: register_component_1.RegisterComponent },
    { path: 'registration/step1', pathMatch: 'full', redirectTo: 'registration' },
    { path: 'registration/step2', pathMatch: 'full', redirectTo: 'registration' }
];
var RegistrationModule = /** @class */ (function () {
    function RegistrationModule() {
    }
    return RegistrationModule;
}());
exports.RegistrationModule = RegistrationModule;
